import { BrowseViewResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import { CodeList } from '@/common';
import env from '@/env';

export const getCodeLists = async ({
  page,
  pageSize,
  search,
  codeType,
}: {
  page: number;
  pageSize: number;
  search: string;
  codeType: string;
}): Promise<BrowseViewResponseDto<CodeList>> => {
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/code-lists?${new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      search: search.toString(),
      codeType: codeType.toString(),
    })}`,
    { method: 'GET' }
  );

  const response = (await fetchResponse.json()) as BrowseViewResponseDto<CodeList>;
  return response;
};
